import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags() {
  return {
    title: "".concat(config.valuePlan.text, " | SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)"),
    keywords: "".concat(config.valuePlan.text, ",SPOOX,\u30B9\u30D7\u30FC\u30AF\u30B9,\u52D5\u753B\u914D\u4FE1,\u30B9\u30AB\u30D1\u30FC\uFF01"),
    description: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)\u3067\u306F\u3001".concat(config.valuePlan.text, "\u306E\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
    og: {
      type: "article",
      url: "".concat(config.host.vod).concat(routes.valuePlan)
    }
  };
}
export default function ValuePlanPageMetaTags() {
  var metatags = tags();
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, metatags));
}